import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import { currentActorId } from '../utils/combat/combatEngine';

// Overlay on the viewport: the foes in combat, and the game-over screen
class CombatStatus extends Component {
  render() {
    const { combat, monsters, party } = this.props.context;
    if (!combat) return null;

    const foes = monsters.filter((m) => combat.monsterIds.includes(m.id));
    // Attacks go to the chosen foe, or the first one if none is chosen / it died
    const targetId = (foes.find((m) => m.id === combat.targetId) || foes[0] || {}).id;
    const actor = party.find((c) => c.id === currentActorId(combat));

    return (
      <div id="combatBanner">
        <div className="combat-round">COMBAT — ROUND {combat.round}{actor && <Fragment> — {actor.name}'s turn</Fragment>}</div>
        {foes.length > 1 && <div className="combat-hint">Click a foe or press TAB to change target</div>}
        {foes.map((m) => (
          <div
            key={m.id}
            className={classNames('combat-foe', { targeted: m.id === targetId })}
            onClick={() => this.props.context.selectTarget(m.id)}
          >
            <span>{m.id === targetId ? '▶ ' : ''}{m.name}</span>
            <div className="stat-bar hp foe">
              <div className="stat-bar-fill" style={{ width: Math.max(0, (m.hp / m.maxHp) * 100) + '%' }} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default withContext(CombatStatus);
